/*eslint-disable*/
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { useHistory } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem";
import search from "api/search/search.js";
import searchRestaurants from "api/search/search-by-name.js";
import SearchInput from "componentCustom/SearchInput.js";
import { NavLink } from "react-router-dom";
import config from "config/config.js";

import styles from "assets/jss/material-dashboard-pro-react/components/footerStyle.js";

const useStyles = makeStyles(styles);

export default function Footer(props) {
  const { updateCity, t, user} = props;
  const classes = useStyles();
  const { fluid, white, rtlActive } = props;
  var container = cx({
    [classes.container]: !fluid,
    [classes.containerFluid]: fluid,
    [classes.whiteColor]: white
  });
  var anchor =
    classes.a +
    cx({
      [" " + classes.whiteColor]: white
    });
  var block = cx({
    [classes.block]: true,
    [classes.whiteColor]: white
  });
  const home = {position: "fixed",
  zIndex: 999,
  bottom: 0,
  left: 0,
  height: "315px",
  width: "100%"}
  const other = {
    height: "315px",
    width: "100%"}

  let history = useHistory();
  console.log(history, t, user);

  const appMenu = () => {
    return (
      <div className="userMenu-big-menu-column-center">
        <div
          className="userMenu-big-menu-column-block"
        >
          <h2
            onClick={() => { this.setState({ openGroup: !this.state.openGroup }); }}
            className={`userMenu-big-menu-title`}
          >
            App
          </h2>
          <div className={`linkgroup`}>
            {/* <div className="megamenuLink">
              <a
                target="_self"
                className="userMenu-big-menu-link"
                // href={lang === 'en'
                //   ? `/_/download-app/`
                //   : `/${this.props.defaultLanguage}/download-app/`
                // }
              >
                Per i ristoratori
              </a>
            </div> */}
            <div className="megamenuLink" style={{ paddingTop: '10px' }}>
              <a
                target="_self"
                className="userMenu-big-menu-link"
                href="/apk/tourist_wallet-release.apk"
              >
                <img style={{ width: '90px' }} src={`https://cdn.foodiestrip.com/background_images/homepage_02/download_app_android.png`} />
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const twMenu = () => {
    return (
      <div className="userMenu-big-menu-column">
        <div className="userMenu-big-menu-column-center">
          <div
            className="userMenu-big-menu-column-block"
          >
            <h2
              className={`userMenu-big-menu-title`}
            >
              Per il business
            </h2>
            <div className={`linkgroup`}>
              <div className="megamenuLink">
                <a
                  target="_self"
                  className="userMenu-big-menu-link"
                  href={user && user.username && user.userDataId && user.userDataId.roles && user.userDataId.roles.length > 1
                    ? 'https://backoffice.touristwallet.it/signup'
                    : 'https://backoffice.touristwallet.it/signup'}
                >
                  Rivendica la tua struttura
                </a>
              </div>
              <div className="megamenuLink">
                <a
                  target="_self"
                  className="userMenu-big-menu-link"
                  href={user && user.username && user.userDataId && user.userDataId.roles && user.userDataId.roles.length > 1
                    ? 'https://backoffice.touristwallet.it/dashboard'
                    : 'https://backoffice.touristwallet.it/login'}
                >
                  Accedi alla tua struttura
                </a>
              </div>
              <div className="megamenuLink">
                <a
                  target="_self"
                  className="userMenu-big-menu-link"
                  href={'/contact-us'}
                >
                  Contattaci
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const contactsMenu = () => {
    return (
      <div className="userMenu-big-menu-column">
        <div className="userMenu-big-menu-column-center">
          <div
            className="userMenu-big-menu-column-block"
          >
            <h2
              className={`userMenu-big-menu-title`}
            >
              Contatti
            </h2>
            <div className={`linkgroup`}>
              {/* <div className="megamenuLink">

                  Tel: +39 06 95 06 0000
              </div>
              <div className="megamenuLink">

                  Fax: +39 06 23 32 59 61
              </div> */}
              <div className="megamenuLink">
                <a
                  target="_self"
                  className="userMenu-big-menu-link"
                  href={null}
                >
                  Mail: info@touristwallet.it
                </a>
              </div>
              <div className="megamenuLink">
                <a
                  target="_self"
                  className="userMenu-big-menu-link"
                  href={''}
                >
                  Contattaci
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const linkMenu = () => {

    const array = [
      {
        name: 'Ritoranti a Roma',
        link: '/search?41.89193@12.51133&Roma'
      },
      {
        name: 'Ristoranti Trastevere',
        link: '/search?41.88333@12.46667&Trastevere'
      },
      {
        name: 'Ritoranti a Civitavecchia',
        link: '/search?41.64931@13.61739&Civitavecchia'
      },
      {
        name: 'Ritoranti a Latina',
        link: '/search?41.46614@12.9043&Latina'
      },
      {
        name: 'Ritoranti a Rieti',
        link: '/search?42.40476@12.85735&Rieti'
      },
      {
        name: 'Ritoranti a Viterbo',
        link: '/search?42.41937@12.1056&Viterbo'
      },
    ]

    return (
      <div className="userMenu-big-menu-column">
        <div className="userMenu-big-menu-column-center">
          <div
            className="userMenu-big-menu-column-block"
          >
            <h2
              className={`userMenu-big-menu-title`}
            >
              Lazio
            </h2>
            <div className={`linkgroup`}>
              {
                array.map((el) => (
                  <div className="megamenuLink" key={el.name}>
                    <a
                      target="_self"
                      className="userMenu-big-menu-link"
                      href={el.link}
                    >
                      {el.name}
                    </a>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <div
        className="home-download-app-container"
        style={{ backgroundImage: `url("https://foodiestrip-eu.s3-eu-west-1.amazonaws.com/tourist_wallet/cover_back_tw2.jpg")` }}
        id="section-to-download-app"
      >
        <div className="home-download-app-text-side">
          {/* <div className="home-download-app-title" style={{ color: '#fff', textShadow: '2px 2px 2px rgba(0,0,0,0.5)' }}>
            TOURISTWALLET
          </div> */}
          <div
            className="home-download-app-title" style={{ color: '#fff',
              textShadow: '2px 2px 2px rgba(0,0,0,0.5)',
              fontSize: '26px',
              lineHeight: '30px' }}
          >
            Scarica l'app
          </div>
          <div
            className="home-download-app-text" style={{ color: '#fff',
              textShadow: '2px 2px 2px rgba(0,0,0,0.5)',
              fontSize: '26px',
              lineHeight: '30px' }}
          >
            Prenota in tempo reale 24h su 24 e 7 giorni su 7 nelle strutture della regione Lazio aderenti al nostro circuito, il tutto in modo facile e veloce
          </div>
          <div className="home-download-app-buttons-container">
            <div className="home-download-app-button">
              <a
                href="/apk/tourist_wallet-release.apk"
                rel="nofollow"
              >
                <img
                  style={{ width: 'calc(100% - 20px)', maxWidth: '180px' }}
                  src={`https://cdn.foodiestrip.com/background_images/homepage_02/download_app_android.png`}
                  // style={{ width: '200px', backgroundColor: '#ffffff', borderRadius: '5px' }}
                />
              </a>
            </div>
          </div>
        </div>
        <div className="home-download-app-image-side">
          <picture>
            <source srcSet={`https://foodiestrip-eu.s3-eu-west-1.amazonaws.com/tourist_wallet/tel_squeeze_touristwallet2.png`} type="image/jpeg" />
            <img
              className="home-download-app-squeeze-page"
              src={`https://foodiestrip-eu.s3-eu-west-1.amazonaws.com/tourist_wallet/tel_squeeze_touristwallet2.png`}
            />
          </picture>
        </div>
      </div>
      <footer style={{
        backgroundColor:'white',
        paddingBottom: '200px',
      }}>
        {/* <FooterContainer
          showCities={false}
        /> */}
        <div className="footercontent_row userfooter">
          <div className="userMenu-big-menu-column" style={{ marginRight: '20px'}}>
            {linkMenu()}
          </div>

          <div className="userMenu-big-menu-column" style={{ marginRight: '20px'}}>
            {twMenu()}
          </div>
          <div className="userMenu-big-menu-column" style={{ marginRight: '20px'}}>
            {appMenu()}
            {/* {contactsMenu()} */}
          </div>

          {/* <DownloadAppMenu
            defaultLanguage={this.props.defaultLanguage}
          />
          <SupportMenu
            defaultLanguage={this.props.defaultLanguage}
          />
          <ForTheOwnerMenu
            defaultLanguage={this.props.defaultLanguage}
          />
          <BannerWebSummitMenu
            defaultLanguage={this.props.defaultLanguage}
          />
          <FoodiestripMenu
            defaultLanguage={this.props.defaultLanguage}
          />
          <BlogMenu
            defaultLanguage={this.props.defaultLanguage}
          />
          <FollowUsMenu
            defaultLanguage={this.props.defaultLanguage}
          /> */}
        </div>
        <a href="https://www.mashfrog.com/it/tourist-wallet" target="_blank">
          <img
            style={{width: '80px'}}
            className="home-logos"
            src={`https://www.mashfrog.com/themes/mashfrog/img/mashfrog_blu.png`}
            onClick
          />
      </a>



      </footer>
      <div className="footer-legal">
        © 2020 Tourist Wallet {' '}
        <span>
          - Mashfrog S.p.A - P.IVA 05842731001 - con sede legale in Via Giacomo Peroni, 400 - 00131 Roma
        </span>
        {' '} - All Rights Reserved /
        <NavLink
          className="footer_link"
          to={`policy-privacy`}
        >
          {' '}Privacy Policy
        </NavLink>
      </div>
    </>

  );
}

Footer.propTypes = {
  updateCity: PropTypes.func.isRequired,
  city: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  user: PropTypes.any
};

Footer.defaultProps = {
  user: null
}
